import axios from "axios";
import MetaTags from 'react-meta-tags';
import React, { useState, useEffect } from "react"
import authHeader from "helpers/authHeader";
import { useHistory } from "react-router-dom";
import $ from 'jquery'
import {
    Table,
    Row,
    Col,
    Card,
    CardBody,
    Container,
    Modal
} from "reactstrap"

import PropTypes from 'prop-types';
import banner from "../../assets/images/banner/banner.jpg";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

//Import StatusDetails
import { getAPIUrl, getAllCustomerAccountListUrl } from "../../helpers/fakebackend_helper"

//Import DeleteCustomerAccount
import { deleteCustomerAccount } from "../../helpers/fakebackend_helper"

const Status = () => {

    const cardBackground = {
        borderRadius: 15,
        flex: 1,
        marginTop: "20px",
        boxShadow: "#504f4f6b 5px 5px 20px"
    }

    const [statusDetails, setStatusDetails] = useState([]);
    const [modal_backdrop, setmodal_backdrop] = useState(false);

    const [showEasing, setshowEasing] = useState("swing");
    const [hideEasing, sethideEasing] = useState("linear");
    const [showMethod, setshowMethod] = useState("fadeIn");
    const [hideMethod, sethideMethod] = useState("fadeOut");
    const [showDuration, setshowDuration] = useState(300);
    const [hideDuration, sethideDuration] = useState(1000);
    const [timeOut, settimeOut] = useState(2000);
    const [extendedTimeOut, setextendedTimeOut] = useState(1000);
    const [isPreloader, setPreloader] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState("");
    const [deleteHolderId, setDeleteHolderId] = useState("");

    function SuccessMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.success(message, "Information");
    }

    function ErrorMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.error(message, "Error");
    }

    const history = useHistory();

    const formButton = {
        marginLeft: "20px",
        backgroundColor: "#9a084f",
        fontSize: "small",
        borderRadius: "0.50rem"
    }

    function tog_backdrop() {
        setmodal_backdrop(!modal_backdrop);
        removeBodyCss();
    }

    function DownloadRegistrationPDF(fileName,id) {
        debugger;
        //Live application url
        //var url = "JSBOnlineAccountAPI/RegistrationPrintPDF/" + fileName;

        //Development url
        var url = getAPIUrl() + "/RegistrationPrintPDF/" + id + ".pdf";

        //axios.get(url, {
        //    responseType: "blob",
        //    headers: authHeader()
        //}).then((response) => {
        //    fileDownload(response.data, fileName);
        //    history.push("/success");
        //}
        //)

        axios({
            url: url, //your url
            method: 'GET',
            responseType: 'blob', // important
            headers: authHeader()
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName + ".pdf"); //or any other extension
            document.body.appendChild(link);
            link.click();
        });

        //var a = $("<a target='_blank' rel='noreferrer'/>");
        //a.attr("download", fileName);
        //a.attr("href", url);
        //$("body").append(a);
        //a[0].click();
        //$("body").remove(a);
    };

    function GetStatus() {

        var authCustomerObject = JSON.parse(localStorage.getItem('authCustomer'));

        //Display StatusDetails
        const StatusModel = {
            MobileNo: authCustomerObject.mobileNo
        };

        setPreloader(true);
        axios.post(getAllCustomerAccountListUrl(), StatusModel, { headers: authHeader() }).then((response) => {
            setStatusDetails(response.data);
            setPreloader(false);
        }, (error) => {
            console.log(error.response);
        });
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    function deleteStatusRows(index, Id) {
        debugger;

        const rows = [...statusDetails];
        rows.splice(index, 1);
        setStatusDetails(rows);

        const deleteStatusModel = {
            RegistrationId: Id
        };

        axios.post(deleteCustomerAccount(), deleteStatusModel, { headers: authHeader() }).then((response) => {
            SuccessMessage(response.data.responseMessage);
            setmodal_backdrop(false);
        }, (error) => {
            ErrorMessage(error.response);
        });
    }

    useEffect(() => {
        debugger;
        if (isPreloader === true) {
            document.getElementById("preloader").style.display = "block";
            document.getElementById("status").style.display = "block";
        } else {
            document.getElementById("preloader").style.display = "none";
            document.getElementById("status").style.display = "none";
        }
    }, [isPreloader]);

    useEffect(() => {
        debugger;
        localStorage.removeItem('registrationHoldersId');
        GetStatus();
    }, []);

    function EditAccount(Id) {
        localStorage.setItem('registrationId', Id.toString());
        history.push('/CreateNewAccount');
    }

    return (
        <React.Fragment>
            <div id="preloader">
                <div id="status">
                    <div className="spinner-chase">
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                        <div className="chase-dot" />
                    </div>
                </div>
            </div>

            <MetaTags>
                <title>JSB-Status</title>
            </MetaTags>
            <Container fluid={true} style={{ overflow: "hidden" }}>
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody style={cardBackground}>
                                <div className="table-responsive" style={{ overflow: "hidden" }}>
                                    <Row>
                                        <Col lg="6">
                                            <h4 className="card-title" style={{ fontSize: "17px", color: "#941116", fontWeight: "bold" }}>See Your Status</h4>
                                        </Col>
                                        <Col>
                                            <div style={{ textAlign: "right" }}>
                                                <input
                                                    type="Button"
                                                    style={formButton}
                                                    className="btn btn-success mt-3 mt-lg-0"
                                                    value="Generate Form"
                                                    onClick={() => {
                                                        localStorage.removeItem('registrationId');
                                                        localStorage.removeItem('registrationHoldersId');
                                                        history.push('/CreateNewAccount');
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <br></br>
                                    <div className="table-responsive">
                                        <table id="dynamic-table" className="table table-striped table-bordered table-hover table-condensed bootstrap-datatable datatable dataTable mb-0" style={{ textAlign: "center"}}>
                                            <thead>
                                                <tr>
                                                    <th style={{ border: "1px solid lightgrey" }}>Last updated</th>
                                                    <th style={{ border: "1px solid lightgrey" }}>Reference No.</th>
                                                    <th style={{ width: "30%", border: "1px solid lightgrey" }}>Customer Name</th>
                                                    <th style={{ border: "1px solid lightgrey" }}>Account Type</th>
                                                    <th style={{ border: "1px solid lightgrey" }}>Entity Type</th>
                                                    <th style={{ width: "10%", border: "1px solid lightgrey" }}>Number of Holder</th>
                                                    <th style={{ border: "1px solid lightgrey" }}>Status</th>
                                                    <th style={{ width: "10%", border: "1px solid lightgrey" }}>Form Filled By</th>
                                                    <th style={{ width: "8%", border: "1px solid lightgrey" }}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody >
                                                {
                                                    statusDetails.map((p, index) => (
                                                        (p.status === "Completed" ? (
                                                            <tr key={index}>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.lastUpdated}</td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.referenceNo}</td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.customerName}</td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.accountTypeName}</td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.entityTypeName}</td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.holdersCount}</td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}><label style={{ color: "green", fontWeight: "bold" }}>{p.status}</label></td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.formFillBy}</td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>
                                                                    <button type="button" className="btn btn-primary"
                                                                        onClick={() => {
                                                                            DownloadRegistrationPDF(p.referenceNo, p.id);
                                                                        }} >
                                                                        <i className="bx bx-download"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ) : null)
                                                    ))
                                                }
                                                {
                                                    statusDetails.map((p, index) => (
                                                        (p.status === "Partially Filled" ? (
                                                            <tr key={index}>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.lastUpdated}</td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.referenceNo}</td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.customerName}</td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.accountTypeName}</td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.entityTypeName}</td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.holdersCount}</td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}><label style={{ color: "red", fontWeight: "bold" }}>{p.status}</label></td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }}>{p.formFillBy}</td>
                                                                <td style={{ border: "1px solid lightgrey", verticalAlign: "middle" }} className="d-flex flex-wrap gap-1">
                                                                    <button
                                                                        type="button" className="btn btn-success"
                                                                        onClick={() => {
                                                                            EditAccount(p.id);
                                                                        }} >
                                                                        <i className="mdi mdi-pencil"></i>

                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-danger"
                                                                        onClick={() => { tog_backdrop(), setDeleteIndex(index), setDeleteHolderId(p.id) }}
                                                                        data-toggle="modal"
                                                                    >  <i className="mdi mdi-trash-can"></i>
                                                                    </button>
                                                                    <Modal
                                                                        isOpen={modal_backdrop}
                                                                        toggle={() => {
                                                                            tog_backdrop();
                                                                        }}
                                                                        backdrop={'static'}
                                                                        id="staticBackdrop"
                                                                    >
                                                                        <div className="modal-header">
                                                                            <h5 className="modal-title" id="staticBackdropLabel">Confirmation</h5>
                                                                            <button type="button" className="btn-close"
                                                                                onClick={() => {
                                                                                    setmodal_backdrop(false);
                                                                                }} aria-label="Close"></button>
                                                                        </div>
                                                                        <div className="modal-body">
                                                                            <p>Are you sure you want to delete the selected account?</p>
                                                                        </div>
                                                                        <div className="modal-footer">
                                                                            <button type="button" className="btn btn-primary" onClick={() => { deleteStatusRows(deleteIndex, p.id) }}>Yes</button>
                                                                            <button type="button" className="btn btn-light" onClick={() => {
                                                                                setmodal_backdrop(false);
                                                                            }}>No</button>

                                                                        </div>
                                                                    </Modal>
                                                                </td>
                                                            </tr>
                                                        ) : null)
                                                    ))
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </React.Fragment >
    )
};

export default Status
